
import { useI18n } from 'src/utils/lni18n';
import { useAtom } from 'jotai';
import { Link, Outlet } from 'react-router-dom';
import { useState } from 'react';
import { coursesAtom } from '../CourseCollectionService';
import CourseFindByStudentClass from './CourseFindByStudentClass';
import { NavLink } from 'react-router-dom';

export default function FindCourses() {

    const { languageService: t } = useI18n();
    const [courseData] = useAtom(coursesAtom);

    const setActive = ({ isActive }: { isActive: boolean }) => isActive ? "active" : "";

    return <div>

        <div className={"scrollContent h-100"} aria-live="polite">
            <div className="card-box big-card-box">
                <div className="card-box-title card-title">
                    <h3>{t.getText("courses")}</h3>
                </div>

                <div className="card-box-content card-body scroller">

                    <div className="custom-tab-heading-list" >
                        <NavLink className={setActive} to="all" >{ t.capitalize( t.getText("all") )}</NavLink>
                        <NavLink className={setActive} to="byclass" >{t.capitalize(t.getText("search.by.class"))}</NavLink>
                    </div>

                    <Outlet />
                </div>
            </div>
        </div>
    </div>



}